module.exports = {
    buildFormState,
};

function buildFormState(formData) {
    return formData;
}
